import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

// SELL05 — marks a merch product as shipping to a physical address; checkout
// asks the buyer for one and the order lands in the Shipping queue.
const DeliverableToggle = ({ deliverable, onCheckBoxChange }) => {
  return (
    <FormControl>
      <FormControlLabel
        control={
            <Checkbox checked={ deliverable || false }
                name='deliverable'
                onChange={onCheckBoxChange}
                size='small'
            />
        }
      label={"This product ships to a physical address"}
      />
      <FormHelperText sx={{ ml: 0 }}>Buyers will be asked for a shipping address when purchasing from the store. Event-page purchases are collected at the venue.</FormHelperText>
    </FormControl>
  );
};

DeliverableToggle.propTypes = {
    deliverable: PropTypes.bool,
    onCheckBoxChange: PropTypes.func
};

export default DeliverableToggle;
